import { isFeatureEnabled } from '@/utils/featureFlags';
export default [
  {
    path: "/tree-permit",
    component: () => import("../layout/PageLayoutWithoutContainer.vue"), 
     meta: { featureFlag: 'VUE_APP_FEATURE_TREE_PERMIT' },
        beforeEnter: (to) => {
          // returning false cancels navigation [2](https://router.vuejs.org/guide/advanced/navigation-guards.html)
          if (!isFeatureEnabled(to.meta.featureFlag)) return false;
          return true;
        },  
    children: [
      {
        path: "",
        name: "Tree Permit Application",
        component: () => import("@/views/TreePermit/TreePermitApplication.vue")
      },
      {
        path: "confirmation/:orderId",
        name: "Permit Fee Confirmation",
        props: true,
        component: () => import("@/views/TreePermit/TreePermitApplication.vue"),
        meta: { confirmation: true, failure: false }
      },
      {
        path: "failure/:orderId",
        name: "Permit Fee Failure",
        component: () => import("@/views/TreePermit/TreePermitApplication.vue"),
        props: true,
        meta: { confirmation: false, failure: true }
      }
    ]
  }
];
